import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // Most reliable combo in 2024–2026 projects
    window.scrollTo(0, 0);                    // fallback
    document.documentElement.scrollTo(0, 0);
    document.body.scrollTo(0, 0);             // sometimes needed

    // Optional: force again after a tiny delay (helps with images/fonts)
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;